<template>
    <div class="order-step-2-variation">
        <div class="order-step-2-variation__col-container" :class="{'order-step-2__col-container--private': mode === 'private'}">
            <div
                v-if="mode === 'business' || (mode==='private' && privateDeliveryDay === 'monday')"
                class="order-step-2-variation__col order-step-2-variation__col-1"
            >
                <h3 class="order-step-2-variation__col-heading">Montag</h3>
                <div class="order-step-2-variation__amount-highlight">
                    {{ amounts.monday }} kg
                </div>
                <div class="range-slider range-slider--on-light-bg">
                    <span class="range-slider__number range-slider__number--selected">2 kg</span>
                    <input
                        :value="amounts.monday"
                        class="range-slider__input"
                        name="amount-monday"
                        type="range"
                        min="2"
                        max="20"
                        @input="updateAmounts($event, 'monday')"
                    >
                    <span class="range-slider__number range-slider__number--total">21 kg</span>
                </div>
            </div>
            <div v-if="mode === 'private'" class="order-step-2-variation__details-col-container order-step-2-variation__details-col-container--private">
                <div class="order-step-2-variation__details-col order-step-2-variation__details-col-1">
                    <a
                        href="#"
                        class="order-step-2-variation__info-link"
                        @click.prevent="toggleInfoModalVisible(`Nach den Empfehlungen der Schweizerischen Gesellschaft für Ernährung sollte eine erwachsene Person täglich 5 Portionen Früchte und Gemüse in verschiedenen Farben zu sich nehmen. Unsere Liefermengen sind so berechnet, dass du täglich mit 1 bis 2 Portionen Früchte oder Gemüse versorgt wirst. Somit deckt der Öpfelchasper 20 bis 40 % deines Bedarfs an Rohkost.`)"
                    >
                        Mengenangaben
                    </a>
                </div>
                <div class="order-step-2-variation__details-col order-step-2-variation__details-col-2">
                    <div class="order-step-2-variation__info">
                        Total {{ totalAmounts }} kg/Woche (ca. {{ peopleAmounts }} Personen)
                    </div>
                </div>
            </div>
            <div
                v-if="mode === 'business' || (mode==='private' && privateDeliveryDay === 'wednesday')"
                class="order-step-2-variation__col order-step-2-variation__col-2"
            >
                <h3 class="order-step-2-variation__col-heading">Mittwoch</h3>
                <div class="order-step-2-variation__amount-highlight">
                    {{ amounts.wednesday }} kg
                </div>
                <div class="range-slider">
                    <span class="range-slider__number range-slider__number--selected">0 kg</span>
                    <input
                        :value="amounts.wednesday"
                        class="range-slider__input"
                        name="amount-wednesday"
                        type="range"
                        min="0"
                        max="20"
                        @input="updateAmounts($event, 'wednesday')"
                    >
                    <span class="range-slider__number range-slider__number--total">21 kg</span>
                </div>
            </div>
        </div>
        <div v-if="mode === 'business'" class="order-step-2-variation__details-col-container">
            <div class="order-step-2-variation__details-col order-step-2-variation__details-col-1">
                <a
                    v-if="mode === 'business'"
                    href="#"
                    class="order-step-2-variation__info-link"
                    @click.prevent="toggleInfoModalVisible(`
                            <div class='text-container'>
                                <h3>Was bedeuten die Mengenangaben Chasperli, Öpfelchasper und Superchasper?</h3>
                                <p>Unsere Mengenangaben stützen sich auf die Empfehlungen der Schweizerischen Gesellschaft für Ernährung. So sollte eine erwachsene Person täglich 5 Portionen Früchte und Gemüse in verschiedenen Farben zu sich nehmen, wobei 1 Portion rund 120 g entspricht. Pro Woche ist dies eine Gesamtmenge von 4.2 kg Gemüse und Früchte pro Person.
                                    <br/><br/>
                                    Das Abo «Bio fürs Büro» kann somit folgenden Bedarf an Früchten und/oder Gemüse decken:
                                    <br/><br/>
                                    Chasperli: 400 g pro Person und Woche (ca. 3 Portionen)<br/>
                                    Öpfelchasper: 600 g pro Person und Woche (ca. 5 Portionen)<br/>
                                    Superchasper: 800 g pro Person und Woche (ca. 7 Portionen)
                                </p>
                            </div>`)"
                >
                    Mengenangaben
                </a>
            </div>
            <div class="order-step-2-variation__details-col order-step-2-variation__details-col-2">
                <div class="order-step-2-variation__info">
                    Total {{ totalAmounts }} kg/Woche (ca. {{ peopleAmounts }} Personen)
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import priceMixin from '../mixins/priceMixin';

export default {
    mixins: [
        priceMixin,
    ],
    computed: {
        ...mapGetters([
            'amounts',
            'appetites',
            'groupedBaskets',
        ]),
        ...mapState({
            appetite: state => state.appetite,
            intervals: state => state.intervals,
            subscriptionType: state => state.subscriptionType,
            orderableIntervals: state => state.orderable.intervals,
            orderableSubscriptionTypes: state => state.orderable.product_groups,
            mode: state => state.mode,
            privateDeliveryDay: state => state.privateDeliveryDay,
        }),
    },
    methods: {
        updateAmounts(e, day) {
            const amount = parseInt(e.target.value, 10);
            this.$store.dispatch('updateAmounts', { amount, day });
        },
        toggleInfoModalVisible(content) {
            this.$store.commit('toggleInfoModalVisible', content);
        },
    },
};
</script>



// WEBPACK FOOTER //
// Amounts.vue?70e6249d